export const UPDATE_FORM_STATUS = 'UPDATE_FORM_STATUS';
export const UPDATE_MANDATORY_FIELDS = 'UPDATE_MANDATORY_FIELDS';
export const UPDATE_DRAWER = 'UPDATE_DRAWER';
export const UPDATE_SIDEBAR_ITEMS = 'UPDATE_SIDEBAR_ITEMS';